import { useEffect, useState } from 'react';
import { EmdrTrainingLevel, EmdrTrainingLevelItem } from '../../../graphql/__generated__/graphql';

export const useEmdrLevels = ({ data, isCA, isSignup }: any) => {
    const [emdrTrainingLevels, setEmdrTrainingLevels] = useState<EmdrTrainingLevelItem[]>();

    useEffect(() => {
        if (data?.emdrTrainingLevels && !emdrTrainingLevels) handleLoadEmdrLevels();
    });

    const handleLoadEmdrLevels = () => {
        try {
            var levels = data.emdrTrainingLevels;

            if (isCA)
                levels = levels.filter((x: EmdrTrainingLevelItem) => {
                    return x.isCA === true;
                });
            else
                levels = levels.filter((x: EmdrTrainingLevelItem) => {
                    return x.isRegular === true;
                });

            if (isSignup)
                levels = levels.filter((x: EmdrTrainingLevelItem) => {
                    return x.allowOnSignup === true;
                });

            setEmdrTrainingLevels(
                levels.reverse().map((x: EmdrTrainingLevelItem) => {
                    return {
                        emdrTrainingLevelId: x.emdrTrainingLevelId,
                        name: x.name,
                    };
                }) as EmdrTrainingLevelItem[]
            );
        } catch (error) {
            console.error('Error processing emdr levels:', error);
        }
    };

    return {
        models: { emdrTrainingLevels },
    };
};
